import React from 'react';
import CanvasWrapper from './components/CanvasWrapper';
import AnimatedEllipse from './components/lines/AnimatedEllipse';

const SplineScene: React.FC = () => (
    <CanvasWrapper>
        <AnimatedEllipse />
    </CanvasWrapper>
);

export default SplineScene;